import {get} from 'lodash';

export const getSelectedDocumentSelector = (state) => {
    return get(state, ['manage', 'documents', 'selectedDocument']);
};
